import { render, staticRenderFns } from "./BotonModulos2.vue?vue&type=template&id=dbc0b36e"
import script from "./BotonModulos2.vue?vue&type=script&lang=js"
export * from "./BotonModulos2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports